export function initCustomerLogosSlider() {
    
    const $slider = $(".customer-logos .slider");
    const $settings = {
        autoplay: true,
        autoplaySpeed: 1500,
        arrows: false,
        dots: false,
        swipeToSlide: true,
        pauseOnHover: false,
        mobileFirst: true,
        slidesToShow: 2.2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 7
                }
            }
        ]
    };
    
    $slider.slick($settings);
}


// WEBPACK FOOTER //
// ./assets/js/modules/customer-logos-slider.js